import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { Limit } from "../LimitRecord";

export const orgLimitsQueryKey = (orgId: string | undefined) => [
  "orgLimits",
  orgId,
];

/**
 * Fetch an org's effective limits as raw rows (tier defaults merged with
 * org-specific overrides server-side).
 *
 * No ``staleTime``: the consumer is the system-user limits editor, which
 * should always show the org's live values when it opens. Pass
 * ``enabled: false`` while the editor is closed so browsing an org page
 * never issues a limits request.
 */
export function useOrgLimits(
  orgId: string | undefined,
  options?: { enabled?: boolean },
) {
  const { limitSummary } = useDomainServices();

  return useQuery<Limit[]>({
    queryKey: orgLimitsQueryKey(orgId),
    queryFn: ({ signal }) =>
      limitSummary.getLimitsForOrg(orgId ?? "", { abortSignal: signal }),
    enabled: (options?.enabled ?? true) && orgId !== undefined,
  });
}
